import React from 'react';
import SocialMediaSelector from './SocialMediaSelector';

const TikTokMediaSelector = (props) => {
	return (
		<SocialMediaSelector
			{...props}
			type='tiktok'
			/*fake_user_token={{
				username:'marcmateos',
				access_token:'act.o42ixfzwBhSKisryAVWZ4dUdEL0BtlbHEc98KiH3C4MXFvU333tEY7JkSzBc!4769.e1',
			}}*/
		/>
	)
}

export default TikTokMediaSelector;